export enum GitRefTagType {
  GIT_REPOSITORY = 'GIT_REPOSITORY',
  GIT_FILE = 'GIT_FILE',
}
